import { useTranslation } from 'react-i18next'

import { ConfigSection } from '../display/ConfigSection'
import { ConfigRow } from '../display/ConfigRow'
import type { ConfigRowData } from '../PartnerConfig.types'

import { Badge, Button, Flex } from '@percent/lemonade'

function ConfigSettingRow({ id, label, tooltip, isLoading, enabled, onToggle, error }: ConfigRowData) {
  const { t } = useTranslation()

  return (
    <ConfigRow id={id} label={label} tooltip={tooltip} isLoading={isLoading} error={error}>
      <Flex align="center" gap={4}>
        <Badge variant={enabled ? 'positive' : 'default'}>
          {enabled ? t('typography.enabled') : t('typography.disabled')}
        </Badge>
        <Button variant="secondary" size="small" onClick={() => onToggle(!enabled)}>
          {enabled ? t('partnerConfig.action.disable') : t('partnerConfig.action.enable')}
        </Button>
      </Flex>
    </ConfigRow>
  )
}

type ToggleSectionProps = {
  rows: ConfigRowData[]
  title: string
}

export function ToggleSection({ rows, title }: ToggleSectionProps) {
  return (
    <ConfigSection title={title}>
      {rows.map(row => (
        <ConfigSettingRow key={row.id} {...row} />
      ))}
    </ConfigSection>
  )
}
